import Vue from 'vue';
import 'jquery'
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapActions, mapMutations } from 'vuex';


@Component({
    name: 'IframeModal',
    components: { },
    computed: {
        ...mapGetters({
        }),
    },
    methods: {
        ...mapActions({
        }),
        ...mapMutations({
        }),
    },
})
export default class IframeModal extends Vue {

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //  

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //   

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    mounted() {
        
    }

    created() {
        
        (window as any).isTeams = this.isTeams;
        (window as any)['showiFrameWindow'] = (newUrl: string, title?: string, style?: any) => {
            if(style.width){
                $('#dvlayerPopup .modal-size').css('width', style.width);
                $('#dvlayerPopup .optional-modal-w-full').removeClass('optional-modal-w-full');
            }

            (window as any).iframeClosed = false;
            $('#dvlayerPopup iframe').attr('src', newUrl);
            if (title !== undefined && title !== '') {
                //$('#dvlayerTitle').html(title);
            }

            var $layer = $('#dvlayerPopup');            
            if ($layer.length) {
                var $ifrm = $layer.find('iframe');
                if ($ifrm.length) {
                    // $ifrm.get(0)?.style.setProperty('width', ((style?.width || 600) + 200) + 'px', 'important');
                    // $ifrm.get(0)?.style.setProperty('height', ((style?.height || 400) + 200) + 'px', 'important');
                    $ifrm.on('load', (e) => {
                        var iframe = e.target;
                        var $html = $((iframe as any).contentDocument).find('html');
                        if ($html.length) {
                            var intervalCount = 10000;
                            var flag = false;
                            var trigger = setInterval(() => {
                                var $common = $((iframe as any).contentDocument).find('#common-wrapper')

                                if ($common.length && !flag) {
                                    flag = true;
                                    $common.addClass('inner-frame');

                                    var $headerTitle = $html.find('.pop-header > .dp-flex .title');
                                    
                                    var $footer = $html.find('.pop-footer > .dp-flex');
        
                                    var $mheader = $layer.find('.modal-header');
                                    var $mfooter = $layer.find('.modal-footer');
        
                                    //$mfooter.empty();
        
                                    if ($headerTitle.length) {
                                        var text = $headerTitle.text();
                                        //$header.appendTo($mheader);
                                        $mheader.find('.title').text(text);
                                        //$html.find('.pop-header').hide();
                                    }
        
                                    if ($footer.length) {
                                        // modal 열때마다 하단의 버튼 중복생성 방지
                                        if(!$mfooter.find('.dp-flex').length){
                                            $footer.appendTo($mfooter);
                                        }
                                        //$html.find('.pop-footer').hide();
                                    }

                                    clearInterval(trigger);
                                }
                                intervalCount--;

                                if (intervalCount < 0 && !flag) {
                                    clearInterval(trigger);
                                }                                
                            }, 11);                           

                            //$html.get(0)?.style.setProperty('overflow', 'hidden', 'important');
                        }

                        // iframe 안에서 window.opener, window.close() 재정의
                        try {
                            var w = $((iframe as any).contentWindow).get(0) as Window;
                            if (w.frameElement != null
                                && w.frameElement.nodeName === "IFRAME"
                                && (w.parent as any).jQuery) {
                                w.opener = w.parent.window;
                                w.close = function(){
                                    ($(w.parent.document).find('#dvlayerPopup a') as any).get(0).click();
                                }
                            }
                        } catch (ex) {
                            
                        }
                    });
                }

                $layer.css({
                    opacity: 0,
                    filter: 'Alpha(Opacity=0)',
                });

                $layer.show();
                $layer.animate({
                    opacity: 1,
                    filter: 'Alpha(Opacity=100)'
                }, {
                    duration: 500,
                    complete: () => {
                        $layer.removeAttr('style');
                        $layer.show();
                    }
                })
            }
        }

        (window as any)['closeFrame'] = function(elem: HTMLElement) {
            var $mfooter = $('#dvlayerPopup').find('.modal-footer');
            $mfooter.empty();    

            $('#dvlayerPopup iframe').attr('src', '');
            $('#dvlayerPopup').hide();

            (window as any).iframeClosed = true;
        }
    }
}
